import { DAY_OFF_OPTIONS } from '../DAY_OFF_OPTIONS';
import { DayOffOptionIdType } from '../types';

export const getDayOffTitleById = (
  id: DayOffOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return DAY_OFF_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: DayOffOptionIdType = 'netflix_chill';
export const getDayOffIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): DayOffOptionIdType | null => {
  const id = DAY_OFF_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
